import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { environment } from "@environments/environment";
import { Address } from "@interfaces/address";

@Injectable({
  providedIn: "root"
})
export class CepService {
  baseUrl = `${environment.api.mv.nf}/empresa/endereco`;

  constructor(private httpService: HttpService) {}

  fetchCep(cep: string) {
    return this.httpService.get<Address>(`${this.baseUrl}/${cep}`);
  }
}
